import { useMemo } from 'react';
import { useCampaigns } from '@/domains/campaigns';
import type { BrandCampaign } from '../types/brand.types';

export type { BrandCampaign };

export function useBrandCampaigns(brandId: string, brandName?: string) {
  const { data: allCampaigns = [], isLoading } = useCampaigns();

  const brandCampaigns = useMemo(() => {
    if (!brandId && !brandName) return [];
    return allCampaigns
      .filter(
        (c) =>
          (brandId && c.brand_id === brandId) ||
          (brandName && c.brand && c.brand.toLowerCase() === brandName.toLowerCase()) ||
          (brandName && c.brand_name && c.brand_name.toLowerCase() === brandName.toLowerCase())
      )
      .map((c) => ({
        id: c.id,
        name: c.name,
        status: c.status,
        start_date: c.start_date,
        end_date: c.end_date,
        total_budget: c.total_budget,
        spent_budget: c.spent_budget,
      }));
  }, [brandId, brandName, allCampaigns]);

  return {
    data: brandCampaigns,
    isLoading,
  };
}
